import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';

import API from '../utils/api';

const AuthCallback = () => {
  const navigate = useNavigate();
  const { updateUser } = useAuth();
  const hasProcessed = useRef(false);
  const [status, setStatus] = useState('Autenticando...');

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        // Get session_id from hash - try both location.hash and full URL
        let sessionId = null;
        const hash = window.location.hash || '';
        const hashMatch = hash.match(/session_id=([^&]+)/);
        if (hashMatch) {
          sessionId = hashMatch[1];
        }
        
        // Also try from full URL in case hash is in different format
        if (!sessionId) {
          const fullUrl = window.location.href;
          const urlMatch = fullUrl.match(/session_id=([^&]+)/);
          if (urlMatch) {
            sessionId = urlMatch[1];
          }
        }

        if (!sessionId) {
          setStatus('Sessao nao encontrada. Redirecionando...');
          setTimeout(() => navigate('/', { replace: true }), 1500);
          return;
        }

        setStatus('Conectando ao servidor...');

        const response = await axios.post(
          `${API}/auth/session?session_id=${sessionId}`,
          {},
          { 
            withCredentials: true,
            timeout: 15000
          }
        );

        if (response.data && response.data.session_token) {
          // Store token in localStorage
          localStorage.setItem('session_token', response.data.session_token);
          axios.defaults.headers.common['Authorization'] = `Bearer ${response.data.session_token}`;
          
          // Store user data
          const { session_token, ...userData } = response.data;
          localStorage.setItem('user_data', JSON.stringify(userData));
          
          setStatus('Login realizado! Redirecionando...');
          updateUser(response.data);
          
          // Small delay to ensure state is saved
          setTimeout(() => {
            navigate('/', { replace: true });
          }, 300);
        } else {
          setStatus('Erro na autenticacao. Tente novamente.');
          setTimeout(() => navigate('/', { replace: true }), 2000);
        }
      } catch (error) {
        const msg = error?.response?.data?.detail || error?.message || 'Erro desconhecido';
        setStatus(`Erro: ${msg}. Redirecionando...`);
        setTimeout(() => navigate('/', { replace: true }), 2000);
      }
    };

    processAuth();
  }, [navigate, updateUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-white">
      <div className="text-center">
        <div className="w-12 h-12 border-4 border-[#FF5A00] border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-slate-600 font-medium">{status}</p>
      </div>
    </div>
  );
};

export default AuthCallback;
